// ─────────────────────────────────────────────
// COLOR PALETTE
// ─────────────────────────────────────────────
export const C = {
  navy:"#0a0f1e",    navyD:"#060b15",  navyL:"#111827",
  green:"#00ff88",   greenL:"#33ffaa", greenD:"#00cc6a",
  red:"#ff4455",     bg:"#0a0f1e",     card:"#111827",
  border:"rgba(255,255,255,0.06)",  borderD:"rgba(255,255,255,0.12)",
  tx:"#f9fafb",      txM:"#9ca3af",    txL:"#4b5563",
};

// ─────────────────────────────────────────────
// TICKER / CHARTER
// ─────────────────────────────────────────────
export const TICKER = "【掲示板】第三区公共壁面プロジェクト・公式楽曲制作など5件のプロジェクトが進行中　—　【商業区】新規登録作品：IK繊維工房 / 池本フィルム社 / 設計局製品室 など計16件　—　【行政】2026年3月度 市議会報告書を公開　財政報告：総税収¥4,832万（前月比+7.2%）　—　【メッセージ】プロジェクトルームの新着トーク3件　—　【手続き】表現者認可申請の受付を継続中　作品出力許可申請：標準3営業日　—　CA指数グローバル平均：0.861（上昇傾向）　—　池本市 市制施行から12日が経過しました　—";

export const CHARTER = "第一条　本市は、仮想空間を創造の基盤として、現実世界との転写を目的とする。 第二条　市民は、創造行為を通じて本市の拡張に貢献する義務を有する。 第三条　本市に登録されたすべての活動は、市の資産台帳に正式に記録される。 第四条　市民は他の市民の創造活動を尊重し、誠実に協働する義務を有する。 第五条　本市の経済活動は、インフラ維持税（1.5%）によって維持される。";

// ─────────────────────────────────────────────
// LOG SEQUENCES  (interval: 600ms, +2s after last)
// ─────────────────────────────────────────────
export const SYNC_LOGS = [
  "現実空間との接続を確立中…",
  "市民行動指針の整合性を確認中…",
  "市民活動ログを同期中…",
  "端末情報の常時提供を記録しました。",
  "同期シーケンスが正常に完了しました。",
  "市民活動の継続をサポートします。",
];

export const DIAGNOSIS_LOGS = [
  "創作活動パターンを解析中…",
  "市の産業区分との整合性を照合中…",
  "過去の活動記録を参照中…",
  "適性診断シーケンスを実行中…",
  "診断結果：適合を承認しました。",
  "表現者として正常に記録されました。",
];

export const ASSET_LOGS = [
  "資産データの整合性を確認中…",
  "市の資産台帳への登録処理中…",
  "出力許可コードを生成中…",
  "資産の市台帳登録処理を実行中…",
  "資産出力許可申請が正常に記録されました。",
];

export const LOGOUT_LOGS = [
  "セッションの終了処理を開始中…",
  "活動ログを市のサーバーに送信中…",
  "端末との同期を切断中…",
  "接続が正常に終了しました。",
];

export const ASSIGN_LOGS = [
  "スキル適合性を照合中…",
  "申請内容を記録中…",
  "起案者への通知を送信中…",
  "参加申請が正常に記録されました。",
];

export const PURCHASE_LOGS = [
  "現実空間への転写リクエストを受理中…",
  "インフラ維持税（1.5%）を計算中…",
  "物質化プロトコルを初期化中…",
  "転写シーケンスを実行中…",
  "物質化申請が正常に受理されました。",
];

// ─────────────────────────────────────────────
// STATIC DATA
// ─────────────────────────────────────────────
export const DOMAINS = ["グラフィック","映像・写真","建築・空間","音楽・音響","プログラミング","文章・編集","ファッション","その他"];

export const MARKET_CATS = ["すべて","服飾","映像","造形","ライセンス","音響","文書"];

export const TABS = [
  { id:"board",  label:"掲示板",    icon:"⊞" },
  { id:"market", label:"商業区",    icon:"◫" },
  { id:"gov",    label:"行政",      icon:"▣" },
  { id:"proc",   label:"手続き",    icon:"⊕" },
  { id:"my",     label:"マイページ", icon:"◉" },
];

export const BOARD_ITEMS_INIT = [
  { reg:"REG-IK-001", title:"第三区 公共壁面ビジュアル制作", dept:"建設局", lead:"Kento", leadId:"IK-2026-0142", skills:["グラフィック","空間設計"], status:"受付中", seats:2,
    desc:"池本市第三区の公共壁面に設置するビジュアルアートの制作プロジェクト。区画の歴史と未来像をグラフィックとして表現する。現地調査・コンセプト策定・デザイン制作・施工立会までを担当市民で分業する。" },
  { reg:"REG-IK-002", title:"市民白書 第二章 映像化", dept:"文化局", lead:"Mio", leadId:"IK-2026-0093", skills:["映像編集","ナレーション"], status:"受付中", seats:1,
    desc:"池本市が発行する市民白書（第五版）の第二章「市民活動の記録」を映像化するプロジェクト。インタビュー素材の編集、ナレーション収録、字幕制作が主なタスク。完成物は市公式アーカイブに収録される。" },
  { reg:"REG-IK-003", title:"厚生局 市民情報設計", dept:"厚生局", lead:"Saki", leadId:"IK-2026-0091", skills:["UI設計","文章"], status:"充足", seats:0,
    desc:"厚生局が市民向けに発信する情報の設計・整備プロジェクト。各種申請フォームのUI改善と案内文書のリライトが中心。市民が迷わず手続きを完了できる情報環境を構築することが目的。" },
  { reg:"REG-IK-004", title:"池本市 公式楽曲の制作と登録", dept:"文化局", lead:"Hiro", leadId:"IK-2026-0084", skills:["作曲","録音"], status:"受付中", seats:3,
    desc:"池本市の公式テーマ楽曲を制作・市台帳登録するプロジェクト。作曲・編曲・録音・ミキシングの各フェーズで複数の市民が協働します。完成後は市公式音楽ライセンスとして商業区に登録されます。" },
  { reg:"REG-IK-005", title:"情報局 通信インフラ記録整備", dept:"情報局", lead:"Toma", leadId:"IK-2026-0076", skills:["ライティング","整理"], status:"受付中", seats:2,
    desc:"池本市の通信インフラ構築過程を文書として整備し公式記録に残すプロジェクト。施工記録・設計資料の収集と整理、記録文書の執筆が主な作業。整備された資料は情報局アーカイブおよび商業区に公開される。" },
];


export const SHOP_META = {
  "第三区縫製所":   { desc:"池本市第三区を拠点とする服飾工房。廃工場の特殊繊維を活用し、構造を持つ衣服を制作する。", grad:"linear-gradient(135deg,#1a2a4a,#2a4060)" },
  "IK繊維工房":    { desc:"市内最大手の繊維制作工房。手縫いから大量生産まで幅広く対応し、市章ワッペンで知られる。", grad:"linear-gradient(135deg,#2a1a3a,#4a2a60)" },
  "第二区工廠":    { desc:"廃材を再構成した造形作品を制作。都市の記憶を素材に閉じ込めることをコンセプトに活動。",  grad:"linear-gradient(135deg,#1a3020,#2a5030)" },
  "市民記録局 映像部": { desc:"市民生活と都市の変遷を映像で記録・保存する公式部門。ポートレートから都市記録まで幅広く制作。", grad:"linear-gradient(135deg,#3a2010,#604020)" },
  "池本特許事務所": { desc:"制作物の知的財産管理を専門とするライセンス窓口。市外利用向けの各種ライセンスを発行する。",  grad:"linear-gradient(135deg,#1a3030,#205050)" },
  "情報局 技術移転室": { desc:"市のインフラ設計図や技術資料の管理・移転を担う部署。設計ライセンス販売が主要業務。",   grad:"linear-gradient(135deg,#2a2030,#403060)" },
  "池本フィルム社": { desc:"市内の映像記録・ドキュメンタリー制作を手がける映像制作会社。公式記録認定作品を多数保有。",  grad:"linear-gradient(135deg,#302010,#504020)" },
  "設計局製品室":  { desc:"池本市設計局が管轄する製品開発部門。建材・什器・フォーム類など実用的な製品の登録・販売を担います。", grad:"linear-gradient(135deg,#102030,#1a3a50)" },
  "音響記録部":    { desc:"市内各区域の音響環境を収録・アーカイブする記録部門。環境音からテーマ音楽まで幅広く制作・販売。",  grad:"linear-gradient(135deg,#201030,#381a50)" },
  "IK出版局":     { desc:"市の公式刊行物・記録誌・写真集を発行する出版部門。すべての刊行物は公式記録として認定される。",   grad:"linear-gradient(135deg,#102018,#1a3828)" },
};

export const MARKET_ITEMS = [
  {
    reg:"ASSET-IK-001", shop:"第三区縫製所", creator:"Kento", name:"無縫製レイヤード・シェル",
    dept:"服飾", price:"¥12,800", ca:"0.912", type:"physical",
    concept:"縫い目のない一枚布から構成されたシェル型の外装衣。池本市第二区の廃工場で発見された特殊繊維を素材として使用。着用者の動作に応じてシルエットが変形する構造を持つ。",
    specs:[{k:"素材",v:"特殊繊維 TYPE-07"},{k:"サイズ",v:"フリーサイズ（可変）"},{k:"重量",v:"約 210g"},{k:"登録日",v:"2026.02.28"}],
  },
  {
    reg:"ASSET-IK-002", shop:"IK繊維工房", creator:"Saki", name:"第三区 深夜の光芒（視聴権）",
    dept:"映像", price:"¥3,200", ca:"0.874", type:"digital",
    concept:"深夜の第三区を10時間にわたり記録した映像作品。無音・定点・無編集。都市の呼吸を視覚化する試みとして制作された。視聴権のみの販売。",
    specs:[{k:"形式",v:"視聴権ライセンス"},{k:"尺",v:"10h 00m 00s"},{k:"解像度",v:"4K / 30fps"},{k:"登録日",v:"2026.03.01"}],
  },
  {
    reg:"ASSET-IK-003", shop:"第二区工廠", creator:"Jun", name:"廃材アセンブル #003",
    dept:"造形", price:"¥28,000", ca:"0.761", type:"physical",
    concept:"池本市内で収集した廃材を接合・再構成した造形作品。素材の傷や変形をそのまま活かすことで、都市の記憶を物体として固定する。No.003はアルミ板と木片の複合体。",
    specs:[{k:"素材",v:"廃材アルミ / 木片"},{k:"サイズ",v:"H42×W28×D15cm"},{k:"重量",v:"約 1.8kg"},{k:"登録日",v:"2026.02.20"}],
  },
  {
    reg:"ASSET-IK-004", shop:"市民記録局 映像部", creator:"Hiro", name:"市民証フォトセット",
    dept:"映像", price:"¥1,500", ca:"0.943", type:"digital",
    concept:"市民証の発行記念として制作された公式フォトセット。市内の主要区域を巡りながら撮影された12枚のポートレート。市民としてのアイデンティティを記録する。",
    specs:[{k:"形式",v:"デジタルデータ"},{k:"枚数",v:"12枚（JPEG/RAW）"},{k:"解像度",v:"6000×4000px"},{k:"登録日",v:"2026.03.02"}],
  },
  {
    reg:"ASSET-IK-005", shop:"池本特許事務所", creator:"Mio", name:"無音展示 映像ライセンス",
    dept:"ライセンス", price:"¥45,000", ca:"0.829", type:"license",
    concept:"第一回無音展示会にて上映されたインスタレーション映像の完全ライセンス。商業利用・展示利用いずれも可。池本市外での使用には別途申請が必要。",
    specs:[{k:"形式",v:"商業ライセンス"},{k:"利用範囲",v:"展示・放映・教育"},{k:"有効期限",v:"発行から2年"},{k:"登録日",v:"2026.02.15"}],
  },
  {
    reg:"ASSET-IK-006", shop:"IK繊維工房", creator:"Aya", name:"手縫い市章ワッペン",
    dept:"服飾", price:"¥2,200", ca:"0.888", type:"physical",
    concept:"池本市の市章を手縫いで刺繍したワッペン。一点ずつ手作業で製作され、わずかな差異が生じる。市民としての帰属を示すアイテムとして設計された。",
    specs:[{k:"素材",v:"コットン / 刺繍糸"},{k:"サイズ",v:"直径 6.5cm"},{k:"製作方法",v:"手縫い / 一点物"},{k:"登録日",v:"2026.03.03"}],
  },
  {
    reg:"ASSET-IK-007", shop:"情報局 技術移転室", creator:"Riku", name:"第一区 設計図ライセンス",
    dept:"ライセンス", price:"¥18,000", ca:"0.795", type:"license",
    concept:"第一区再開発プロジェクトの設計図面ライセンス。建築・空間設計を専門とする市民による制作。図面データの使用権と参照権を含む。改変には別途申請が必要。",
    specs:[{k:"形式",v:"設計図ライセンス"},{k:"ファイル形式",v:"DWG / PDF"},{k:"利用範囲",v:"参照・非改変使用"},{k:"登録日",v:"2026.02.22"}],
  },
  {
    reg:"ASSET-IK-008", shop:"池本フィルム社", creator:"Toma", name:"通信網記録 フルパッケージ",
    dept:"映像", price:"¥5,800", ca:"0.911", type:"digital",
    concept:"池本市の通信インフラ構築記録を完全パッケージ化した映像・ドキュメントセット。施工過程・設計資料・インタビュー映像を含む。市の公式記録として認定済み。",
    specs:[{k:"形式",v:"デジタルパッケージ"},{k:"内容",v:"映像4本 / 資料一式"},{k:"総容量",v:"約 8.4GB"},{k:"登録日",v:"2026.03.01"}],
  },
  {
    reg:"ASSET-IK-009", shop:"設計局製品室", creator:"Yui", name:"可変間仕切りパネル TYPE-A",
    dept:"造形", price:"¥38,500", ca:"0.847", type:"physical",
    concept:"池本市設計局が開発した軽量アルミ製の可変間仕切りパネル。磁気接合システムにより工具不要で組立・分解が可能。市内施設への設置実績多数。",
    specs:[{k:"素材",v:"陽極酸化アルミ"},{k:"サイズ",v:"W90×H200cm"},{k:"重量",v:"約 4.2kg"},{k:"登録日",v:"2026.03.04"}],
  },
  {
    reg:"ASSET-IK-010", shop:"音響記録部", creator:"Nao", name:"第一区 環境音アーカイブ Vol.1",
    dept:"音響", price:"¥1,800", ca:"0.864", type:"digital",
    concept:"第一区の路地・広場・駅前などで収録した環境音のアーカイブパッケージ。用途フリーのロイヤリティフリー音源として利用可能。全22トラック収録。",
    specs:[{k:"形式",v:"WAV / 24bit 48kHz"},{k:"トラック数",v:"22トラック"},{k:"総尺",v:"約 3h 12m"},{k:"登録日",v:"2026.03.03"}],
  },
  {
    reg:"ASSET-IK-011", shop:"第三区縫製所", creator:"Ren", name:"解体再生テキスタイル No.7",
    dept:"服飾", price:"¥8,400", ca:"0.893", type:"physical",
    concept:"廃棄衣料を解体・染色・再織した一点物のテキスタイル素材。各ロールに固有の管理番号が付与されます。クリエイターへの素材提供を目的として制作されました。",
    specs:[{k:"素材",v:"再生綿 / 廃棄繊維混紡"},{k:"サイズ",v:"約 1.2m × 3.5m (ロール)"},{k:"重量",v:"約 1.1kg"},{k:"登録日",v:"2026.03.05"}],
  },
  {
    reg:"ASSET-IK-012", shop:"IK出版局", creator:"Ami", name:"池本市民白書 第五版（PDF版）",
    dept:"文書", price:"¥500", ca:"0.978", type:"digital",
    concept:"池本市が定期発行する市民活動の公式記録誌。第五版では市制開始から現在までの統計・インタビュー・プロジェクト記録を収録。全市民への公開義務文書。",
    specs:[{k:"形式",v:"PDF / epub"},{k:"ページ数",v:"184ページ"},{k:"言語",v:"日本語"},{k:"登録日",v:"2026.03.01"}],
  },
  {
    reg:"ASSET-IK-013", shop:"池本フィルム社", creator:"Kai", name:"市制施行式典 記録映像",
    dept:"映像", price:"¥2,400", ca:"0.955", type:"digital",
    concept:"池本市の市制施行式典を記録した公式映像。式典全編・来賓挨拶・市民パフォーマンスの3パートで構成。市の公式アーカイブとして永続的に保存される。",
    specs:[{k:"形式",v:"デジタルデータ"},{k:"尺",v:"2h 44m"},{k:"解像度",v:"4K / 60fps"},{k:"登録日",v:"2026.02.10"}],
  },
  {
    reg:"ASSET-IK-014", shop:"音響記録部", creator:"Hiro", name:"池本市公式テーマ音源（β版）",
    dept:"音響", price:"¥0", ca:"0.921", type:"digital",
    concept:"市民の共作によって制作中の池本市公式テーマ楽曲のβ版音源。現在もプロジェクトが進行中のため、β版として無償公開中。最終版は正式ライセンスにて販売予定。",
    specs:[{k:"形式",v:"MP3 / 320kbps"},{k:"尺",v:"3m 52s"},{k:"ライセンス",v:"パブリックドメイン（β版）"},{k:"登録日",v:"2026.03.06"}],
  },
  {
    reg:"ASSET-IK-015", shop:"設計局製品室", creator:"Riku", name:"市民活動記録用 標準フォーム集",
    dept:"文書", price:"¥300", ca:"0.851", type:"digital",
    concept:"市民が各種活動を記録・申請するための標準フォームテンプレート集。申請書・報告書・契約書など17種類を収録。プリント対応・デジタル記入両対応。",
    specs:[{k:"形式",v:"PDF / Googleフォーム連携"},{k:"点数",v:"17種類"},{k:"更新",v:"随時"},{k:"登録日",v:"2026.03.04"}],
  },
  {
    reg:"ASSET-IK-016", shop:"IK出版局", creator:"Nao", name:"都市記録写真集 第一集",
    dept:"映像", price:"¥6,200", ca:"0.906", type:"digital",
    concept:"池本市内の各区域を記録した写真集の電子版。第一集は主に第一区〜第三区の建築・路地・市民の日常を収録。市の公式記録写真として認定。",
    specs:[{k:"形式",v:"デジタル電子書籍"},{k:"点数",v:"210枚"},{k:"解像度",v:"300dpi"},{k:"登録日",v:"2026.03.02"}],
  },
];

// ─────────────────────────────────────────────
// UTILITY FUNCTIONS
// ─────────────────────────────────────────────

// ランダム微変動
export const nudge = (v) => Math.max(1000, Math.min(9999, Math.round(v + (Math.random()-0.5)*12)));

// 市民ID生成
export const randId = () => "IK-2026-" + String(Math.floor(1000+Math.random()*9000));

// インフラ維持税計算 (1.5%)
export const calcTax = (priceStr) => {
  const num = parseInt((priceStr||"0").replace(/[¥,]/g,""), 10) || 0;
  const tax = Math.round(num * 0.015);
  return { total: "¥" + (num+tax).toLocaleString(), tax: "¥" + tax.toLocaleString() };
};

// 市民ID形式バリデーション: IK-YYYY-NNNN
export const validateCitizenId = (id) => /^IK-\d{4}-\d{4}$/.test(id.trim());

// ログシーケンス実行 (600ms間隔、最後のログ後+2秒待機)
export const runSequence = (seq, setLogs, onDone) => {
  setLogs([]);
  let i = 0;
  const INTERVAL = 600;
  const FINAL_DELAY = 2000;
  const step = () => {
    if (i >= seq.length) {
      setTimeout(onDone, FINAL_DELAY);
      return;
    }
    setLogs((p) => [...p, seq[i]]);
    i++;
    setTimeout(step, INTERVAL);
  };
  setTimeout(step, 200);
};
